<template>
  <div :class="{ [$style.overlay]: true, [$style.fullheight]: fullScreen }">
    <div :class="{ [$style.container]: true, [$style.fullheight]: fullScreen }">
      <div
        :class="{
          [$style.child]: true,
          [$style.first]: true,
          [$style.black]: isBlack,
        }"
      />
      <div
        :class="{
          [$style.child]: true,
          [$style.second]: true,
          [$style.black]: isBlack,
        }"
      />
      <div
        :class="{
          [$style.child]: true,
          [$style.third]: true,
          [$style.black]: isBlack,
        }"
      />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    isBlack: {
      type: Boolean,
      default: true,
    },
    fullScreen: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" module>
@import '@design';
.overlay {
  height: 100%;
  display: flex;
  justify-content: center;
  padding-top: 9px;
  padding-bottom: 9px;

  &.fullheight {
    height: 100vh;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .container {
    width: 50px;
    text-align: center;
    display: flex;
    justify-content: space-between;

    .child {
      width: 10px;
      height: 10px;
      background-color: #fff;
      border-radius: 100%;
      display: inline-block;
      -webkit-animation: bouncedelay 1.4s infinite ease-in-out both;
      animation: bouncedelay 1.4s infinite ease-in-out both;

      &.black {
        background-color: black;
      }

      &.first {
        -webkit-animation-delay: -0.32s;
        animation-delay: -0.32s;
      }

      &.second {
        -webkit-animation-delay: -0.16s;
        animation-delay: -0.16s;
      }
    }
  }
}

@-webkit-keyframes bouncedelay {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
  }
}

@keyframes bouncedelay {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
</style>
